import { combineReducers } from 'redux';

import sinisterCards from './sinister-cards';
import coverages from './coverage';

const appReducer = combineReducers({
  sinisterCards,
  coverages,
});

const rootReducer = (state, action) => {
  if (action.type === 'USER_LOGGED_OUT') {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
